// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Thicker-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Thicker-Extralight.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_wrapper {
  width: 100%;
  height: 80px;
  background: #fff;
  position: fixed;
  z-index: 99;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5vw !important;
box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
}

.header-main {
  width: 100%;
  margin: auto;
}

/* .header_left>img {
  width: 228px;
  height: 43px;
} */


.header_logo {
  width:230px;
  height: 60px;
}

.header_hamburger_btn_div {
  display: none;
}

.header_links {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 80px;
}

@font-face {
  font-family: thicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: mediumThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.header_link {
  color: #000;
  font-family: thicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  text-transform: uppercase;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  margin: 0px;
}

.header_popover {
  margin-top: 10px;
  box-shadow: none;
}

.header_popover_div {
  width: 140px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
}

.header_popover_link {
  color: #000;
  font-family: mediumThicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-transform: capitalize;
}

.header_find_your_race_btn {
  color: #fff;
  font-family: thicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 126.6%;
  text-transform: uppercase;

  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #ba1e24;
}

@media screen and (max-width: 1200px) {
  .header_wrapper {
    height: 80px;
    justify-content: space-between;
    padding: 0 50px;
  }

  .header_left>img {
    width: 228px;
    height: 43px;
  }

  .header_links {
    align-items: center;
    flex-direction: row;
    gap: 50px;
  }

  .header_link {
    font-size: 16px;
    line-height: 100%;
    gap: 2px;
  }

  .header_popover {
    margin-top: 10px;
  }

  .header_popover_div {
    width: 140px;
    padding: 8px 12px;
    flex-direction: column;
  }

  .header_popover_link {
    font-size: 16px;
    line-height: 28px;
  }

  .header_find_your_race_btn {
    font-size: 16px;
    line-height: 126.6%;
    padding: 10px;
    gap: 10px;
  }
}

@media screen and (max-width: 1024px) {
  .header_wrapper {
    height: 70px;
    justify-content: space-between;
    padding: 0 40px;
  }

  .header_logo {
    width: 210px;
    height: 45px;
    margin-left: -30px;
  }

  .header_links {
    align-items: center;
    flex-direction: row;
    gap: 40px;
  }

  .header_link {
    font-size: 16px;
    line-height: 100%;
    gap: 2px;
  }

  .header_popover {
    margin-top: 10px;
  }

  .header_popover_div {
    width: 140px;
    padding: 8px 12px;
    flex-direction: column;
  }

  .header_popover_link {
    font-size: 16px;
    line-height: 28px;
  }

  .header_find_your_race_btn {
    font-size: 14px;
    line-height: 126.6%;
    padding: 10px 14px;
    gap: 10px;
  }
}

@media screen and (max-width: 800px) {
  .header_wrapper {
    height: 60px;
    justify-content: space-between;
    padding: 0 30px;
  }

  .header_logo {
    width: 180px;
    height: 36px;
  }

  .header_links {
    align-items: center;
    flex-direction: row;
    gap: 30px;
  }

  .header_link {
    font-size: 14px;
    line-height: 100%;
    gap: 2px;
  }

  .header_popover {
    margin-top: 10px;
  }

  .header_popover_div {
    width: 120px;
    padding: 4px 10px;
    flex-direction: column;
  }

  .header_popover_link {
    font-size: 14px;
    line-height: 28px;
  }

  .header_find_your_race_btn {
    font-size: 12px;
    line-height: 126.6%;
    padding: 8px 12px;
    gap: 10px;
  }
}

@media screen and (max-width: 700px) {
  .header_links {
    align-items: center;
    flex-direction: row;
    gap: 20px;
  }
}

@media screen and (max-width: 600px) {
  .header_wrapper {
    height: 60px;
    justify-content: space-between;
    padding: 0 30px;
  }

  .header_logo {
    width: 180px;
    height: 36px;
  }

  .header_hamburger_btn_div {
    display: flex;
  }

  .header_right {
    display: none;
  }

  .header_links {
    align-items: center;
    flex-direction: row;
    gap: 30px;
  }

  .header_link {
    font-size: 14px;
    line-height: 100%;
    gap: 2px;
  }

  .header_popover {
    margin-top: 10px;
  }

  .header_popover_div {
    width: 120px;
    padding: 4px 10px;
    flex-direction: column;
  }

  .header_popover_link {
    font-size: 14px;
    line-height: 28px;
  }

  .header_find_your_race_btn {
    font-size: 12px;
    line-height: 126.6%;
    padding: 8px 12px;
    gap: 10px;
  }

  .header_drawer_main_div {
    width: 300px;
    height: 100vh;
    padding: 16px;
    background-color: black;
  }

  .header_hamburger_icon {
    font-size: 30px;
    cursor: pointer;
  }

  .header_cancel_icon {
    font-size: 30px;
    cursor: pointer;
    color: white !important;
  }

  .drawer_header {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  .drawer_header_logo {
    width: 150px;
    height: 35px;
    margin-left: -12px;
  }

  .header_drawer_links_div {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .drawer_sub_links_toggler {
    display: flex;
    align-items: center;
    color: #fff;
    font-family: thicker;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    text-transform: uppercase;
    gap: 2px;
    cursor: pointer;
    margin: 0 !important;
  }

  .drawer_sub_links_div {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 6px 16px 0 16px;
  }

  .header_drawer_link {
    color: #fff;
    font-family: thicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    text-transform: uppercase;
    gap: 4px;
    cursor: pointer;
    margin-top: 12px 0;
  }

  .drawer_sub_link {
    color: #fff;
    font-family: mediumThicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    text-transform: capitalize;
  }

  .header_drawer_btn {
    width: 160px;
    height: 40px;
    color: #fff;
    font-family: thicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 126.6%;
    text-transform: uppercase;

    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #ba1e24;
  }
}

@media screen and (max-width: 450px) {
  .header_wrapper {
    height: 60px;
    justify-content: space-between;
    padding: 0 16px;
  }

  .header_logo {
    width: 180px;
    height: 36px;
    margin-top: 5px;
  }

  .header_hamburger_btn_div {
    display: flex;
  }

  .header_right {
    display: none;
  }

  .header_links {
    align-items: center;
    flex-direction: row;
    gap: 30px;
  }

  .header_link {
    font-size: 14px;
    line-height: 100%;
    gap: 2px;
  }

  .header_popover {
    margin-top: 10px;
  }

  .header_popover_div {
    width: 120px;
    padding: 4px 10px;
    flex-direction: column;
  }

  .header_popover_link {
    font-size: 14px;
    line-height: 28px;
  }

  .header_find_your_race_btn {
    font-size: 12px;
    line-height: 126.6%;
    padding: 8px 12px;
    gap: 10px;
  }

  .header_drawer_main_div {
    width: 300px;
    height: 100vh;
    padding: 16px;
  }

  .header_hamburger_icon {
    font-size: 30px;
  }

  .header_cancel_icon {
    font-size: 30px;
  }

  .drawer_header {
    margin-bottom: 30px;
  }

  .drawer_header_logo {
    width: 150px;
    height: 35px;
  }

  .header_drawer_links_div {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .drawer_sub_links_toggler {
    font-size: 18px;
  }

  .drawer_sub_links_div {
    width: 100%;
    flex-direction: column;
    padding: 6px 16px 0 16px;
  }

  .header_drawer_link {
    font-size: 16px;
    line-height: 24px;
    margin-top: 12px;
    margin-bottom: 3px;
  }

  .drawer_sub_link {
    font-size: 16px;
    line-height: 28px;
  }

  .header_drawer_btn {
    width: 150px;
    height: 40px;
    font-size: 14px;
    padding: 10px;
    gap: 10px;
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/header/header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B,8CAA8C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;GAGG;;;AAGH;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,4CAAoD;AACtD;;AAEA;EACE,0BAA0B;EAC1B,4CAAsD;AACxD;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;;EAEzB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,QAAQ;IACR,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,QAAQ;IACR,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;;IAEzB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;AACF","sourcesContent":[".header_wrapper {\n  width: 100%;\n  height: 80px;\n  background: #fff;\n  position: fixed;\n  z-index: 99;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 5vw !important;\nbox-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;\n}\n\n.header-main {\n  width: 100%;\n  margin: auto;\n}\n\n/* .header_left>img {\n  width: 228px;\n  height: 43px;\n} */\n\n\n.header_logo {\n  width:230px;\n  height: 60px;\n}\n\n.header_hamburger_btn_div {\n  display: none;\n}\n\n.header_links {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 80px;\n}\n\n@font-face {\n  font-family: thicker;\n  src: url(../../../assets/fonts/Thicker-Semibold.otf);\n}\n\n@font-face {\n  font-family: mediumThicker;\n  src: url(../../../assets/fonts/Thicker-Extralight.otf);\n}\n\n.header_link {\n  color: #000;\n  font-family: thicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  text-transform: uppercase;\n  list-style: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  cursor: pointer;\n  margin: 0px;\n}\n\n.header_popover {\n  margin-top: 10px;\n  box-shadow: none;\n}\n\n.header_popover_div {\n  width: 140px;\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: column;\n}\n\n.header_popover_link {\n  color: #000;\n  font-family: mediumThicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  text-transform: capitalize;\n}\n\n.header_find_your_race_btn {\n  color: #fff;\n  font-family: thicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 126.6%;\n  text-transform: uppercase;\n\n  display: flex;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  background: #ba1e24;\n}\n\n@media screen and (max-width: 1200px) {\n  .header_wrapper {\n    height: 80px;\n    justify-content: space-between;\n    padding: 0 50px;\n  }\n\n  .header_left>img {\n    width: 228px;\n    height: 43px;\n  }\n\n  .header_links {\n    align-items: center;\n    flex-direction: row;\n    gap: 50px;\n  }\n\n  .header_link {\n    font-size: 16px;\n    line-height: 100%;\n    gap: 2px;\n  }\n\n  .header_popover {\n    margin-top: 10px;\n  }\n\n  .header_popover_div {\n    width: 140px;\n    padding: 8px 12px;\n    flex-direction: column;\n  }\n\n  .header_popover_link {\n    font-size: 16px;\n    line-height: 28px;\n  }\n\n  .header_find_your_race_btn {\n    font-size: 16px;\n    line-height: 126.6%;\n    padding: 10px;\n    gap: 10px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .header_wrapper {\n    height: 70px;\n    justify-content: space-between;\n    padding: 0 40px;\n  }\n\n  .header_logo {\n    width: 210px;\n    height: 45px;\n    margin-left: -30px;\n  }\n\n  .header_links {\n    align-items: center;\n    flex-direction: row;\n    gap: 40px;\n  }\n\n  .header_link {\n    font-size: 16px;\n    line-height: 100%;\n    gap: 2px;\n  }\n\n  .header_popover {\n    margin-top: 10px;\n  }\n\n  .header_popover_div {\n    width: 140px;\n    padding: 8px 12px;\n    flex-direction: column;\n  }\n\n  .header_popover_link {\n    font-size: 16px;\n    line-height: 28px;\n  }\n\n  .header_find_your_race_btn {\n    font-size: 14px;\n    line-height: 126.6%;\n    padding: 10px 14px;\n    gap: 10px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .header_wrapper {\n    height: 60px;\n    justify-content: space-between;\n    padding: 0 30px;\n  }\n\n  .header_logo {\n    width: 180px;\n    height: 36px;\n  }\n\n  .header_links {\n    align-items: center;\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .header_link {\n    font-size: 14px;\n    line-height: 100%;\n    gap: 2px;\n  }\n\n  .header_popover {\n    margin-top: 10px;\n  }\n\n  .header_popover_div {\n    width: 120px;\n    padding: 4px 10px;\n    flex-direction: column;\n  }\n\n  .header_popover_link {\n    font-size: 14px;\n    line-height: 28px;\n  }\n\n  .header_find_your_race_btn {\n    font-size: 12px;\n    line-height: 126.6%;\n    padding: 8px 12px;\n    gap: 10px;\n  }\n}\n\n@media screen and (max-width: 700px) {\n  .header_links {\n    align-items: center;\n    flex-direction: row;\n    gap: 20px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .header_wrapper {\n    height: 60px;\n    justify-content: space-between;\n    padding: 0 30px;\n  }\n\n  .header_logo {\n    width: 180px;\n    height: 36px;\n  }\n\n  .header_hamburger_btn_div {\n    display: flex;\n  }\n\n  .header_right {\n    display: none;\n  }\n\n  .header_links {\n    align-items: center;\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .header_link {\n    font-size: 14px;\n    line-height: 100%;\n    gap: 2px;\n  }\n\n  .header_popover {\n    margin-top: 10px;\n  }\n\n  .header_popover_div {\n    width: 120px;\n    padding: 4px 10px;\n    flex-direction: column;\n  }\n\n  .header_popover_link {\n    font-size: 14px;\n    line-height: 28px;\n  }\n\n  .header_find_your_race_btn {\n    font-size: 12px;\n    line-height: 126.6%;\n    padding: 8px 12px;\n    gap: 10px;\n  }\n\n  .header_drawer_main_div {\n    width: 300px;\n    height: 100vh;\n    padding: 16px;\n    background-color: black;\n  }\n\n  .header_hamburger_icon {\n    font-size: 30px;\n    cursor: pointer;\n  }\n\n  .header_cancel_icon {\n    font-size: 30px;\n    cursor: pointer;\n    color: white !important;\n  }\n\n  .drawer_header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 30px;\n  }\n\n  .drawer_header_logo {\n    width: 150px;\n    height: 35px;\n    margin-left: -12px;\n  }\n\n  .header_drawer_links_div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .drawer_sub_links_toggler {\n    display: flex;\n    align-items: center;\n    color: #fff;\n    font-family: thicker;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    text-transform: uppercase;\n    gap: 2px;\n    cursor: pointer;\n    margin: 0 !important;\n  }\n\n  .drawer_sub_links_div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 6px 16px 0 16px;\n  }\n\n  .header_drawer_link {\n    color: #fff;\n    font-family: thicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    text-transform: uppercase;\n    gap: 4px;\n    cursor: pointer;\n    margin-top: 12px 0;\n  }\n\n  .drawer_sub_link {\n    color: #fff;\n    font-family: mediumThicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 28px;\n    text-transform: capitalize;\n  }\n\n  .header_drawer_btn {\n    width: 160px;\n    height: 40px;\n    color: #fff;\n    font-family: thicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 126.6%;\n    text-transform: uppercase;\n\n    display: flex;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    background: #ba1e24;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .header_wrapper {\n    height: 60px;\n    justify-content: space-between;\n    padding: 0 16px;\n  }\n\n  .header_logo {\n    width: 180px;\n    height: 36px;\n    margin-top: 5px;\n  }\n\n  .header_hamburger_btn_div {\n    display: flex;\n  }\n\n  .header_right {\n    display: none;\n  }\n\n  .header_links {\n    align-items: center;\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .header_link {\n    font-size: 14px;\n    line-height: 100%;\n    gap: 2px;\n  }\n\n  .header_popover {\n    margin-top: 10px;\n  }\n\n  .header_popover_div {\n    width: 120px;\n    padding: 4px 10px;\n    flex-direction: column;\n  }\n\n  .header_popover_link {\n    font-size: 14px;\n    line-height: 28px;\n  }\n\n  .header_find_your_race_btn {\n    font-size: 12px;\n    line-height: 126.6%;\n    padding: 8px 12px;\n    gap: 10px;\n  }\n\n  .header_drawer_main_div {\n    width: 300px;\n    height: 100vh;\n    padding: 16px;\n  }\n\n  .header_hamburger_icon {\n    font-size: 30px;\n  }\n\n  .header_cancel_icon {\n    font-size: 30px;\n  }\n\n  .drawer_header {\n    margin-bottom: 30px;\n  }\n\n  .drawer_header_logo {\n    width: 150px;\n    height: 35px;\n  }\n\n  .header_drawer_links_div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .drawer_sub_links_toggler {\n    font-size: 18px;\n  }\n\n  .drawer_sub_links_div {\n    width: 100%;\n    flex-direction: column;\n    padding: 6px 16px 0 16px;\n  }\n\n  .header_drawer_link {\n    font-size: 16px;\n    line-height: 24px;\n    margin-top: 12px;\n    margin-bottom: 3px;\n  }\n\n  .drawer_sub_link {\n    font-size: 16px;\n    line-height: 28px;\n  }\n\n  .header_drawer_btn {\n    width: 150px;\n    height: 40px;\n    font-size: 14px;\n    padding: 10px;\n    gap: 10px;\n    margin-top: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
